import { fetchFromOldApi } from '~/services/Http';

export type CoreCompetencyType = {
  fCompCoreCompetency: string;
  fCompCoreCompetencyInfo: string;
  fCompCoreCompetencySkill: number;
  fCompCoreCompetencyTarget: number;
};

export type OtherCompetencyType = {
  fCompOtherCompetency: string;
  fCompOtherCompetencyInfo: string;
  fCompOtherCompetencySkill: number;
  fCompOtherCompetencyTarget: number;
};

export type PosRelCompType = {
  fCompPosRelatedCompetency: string;
  fCompPosRelatedCompetencyInfo: string;
  fCompPosRelatedCompetencySkill: number;
  fCompPosRelatedCompetencyTarget: number;
};

export type ProfCompType = {
  fCompProfCompetency: string;
  fCompProfCompetencyInfo: string;
  fCompProfCompetencySkill: number;
  fCompProfCompetencyTarget: number;
};

export type TransactionInfoType = {
  fEmpId: number;
  fTransactionComment: string;
  fTransactionEnteredFirstname: string;
  fTransactionEnteredLastname: string;
  fTransactionEnteredTime: string;
  fTransactionId: number;
  fTransactionType: string;
};

export type Competency = {
  coreCompetencies: CoreCompetencyType[];
  otherCompetencies: OtherCompetencyType[];
  posRelatedCompetencies: PosRelCompType[];
  profCompetencies: ProfCompType[];
  transactionInfo: TransactionInfoType;
};

export type Education = {
  fEduDegreeId: number;
  fEduDegreeEmpId: number;
  fEduDegreeType: string;
  fEduDegreeInstitution: string;
  fEduDegreeSubject: string;
  fEduDegreeStartDate: string;
  fEduDegreeEndDate: string;
  fEduDegreeInfo: string;
  fEduDegreeAttachmentId: number;
  fEduDegreeAttachmentName: string;
};

export type DevPlanActivitiesType = {
  fDevPlanActDevAction: string;
  fDevPlanActDevArea: string;
  fDevPlanActDevGoal: string;
  fDevPlanActDevMethod: string;
  fDevPlanActDevMethodType: string;
  fDevPlanActInfo: string;
  fDevPlanActStatus: string;
  fDevPlanActEndDate?: string;
};

export type DevPlan = {
  devPlanActivities: DevPlanActivitiesType[];
};

export const getEmpDevCompetencies = (empId: number): Promise<Competency> => {
  return fetchFromOldApi(`/json/employee/${empId}/dev/competency`).then((r) =>
    r.json(),
  );
};

export const getEmpDevEducation = (empId: number): Promise<Education[]> => {
  return fetchFromOldApi(`/json/employee/${empId}/dev/edu/degree`).then((r) =>
    r.json(),
  );
};

export const getEmpDevPlans = (empId: number): Promise<DevPlan> => {
  return fetchFromOldApi(`/json/employee/${empId}/dev/plans`).then((r) =>
    r.json(),
  );
};
